import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M6.5 15H6V9h.5c.3 0 .5-.2.5-.5S6.8 8 6.5 8h-3c-.3 0-.5.2-.5.5s.2.5.5.5H4v6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM11.5 15H11V9h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5s.2.5.5.5H9v6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM16.5 15H16V9h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5s.2.5.5.5h.5v6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM17.5 18h-15c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h15c.3 0 .5.2.5.5s-.2.5-.5.5zM17.8 6.3l-7.6-4.2c-.1-.1-.3-.1-.4 0L2.2 6.3c-.3.2-.2.7.2.7h15.3c.3 0 .4-.5.1-.7z',
  ],
  height: 20,
  width: 20,
});
